module.exports = __webpack_public_path__ + "media/src/images/empty-icon8-7e9395acb08c999bd741defee01e03e8.png";